<template>
    <nav class="navbar" id="navbar">
        <div class="nav-pad">
            <div class="navbar-inner">
                <div class="navbar-logo">
                    <router-link to="/" @click="pageScrollTop">
                        <div class="navbar-logo-img">
                            <img src="./assets/images/logos/morula.png" alt="morula rs melinda 2"/>
                        </div>
                    </router-link>
                </div>
                <div class="navbar-menu" id="navbar-menu">
                    <div class="nm-inner">
                        <div class="nm-part">
                            <router-link to="/" class="nm-part-link" @click="menuToggle">Home</router-link>
                        </div>
                        <div class="nm-part">
                            <router-link to="/" class="nm-part-link" @click="menuToggle(); scrollSection('section-service');">Layanan Kami</router-link>
                        </div>
                        <div class="nm-part">
                            <router-link to="/" class="nm-part-link" @click="menuToggle(); scrollSection('section-doctor');">Jadwal Dokter</router-link>
                        </div>
                        <div class="nm-part">
                            <router-link to="/" class="nm-part-link" @click="menuToggle(); scrollSection('section-appointment');">Buat Janji</router-link>
                        </div>
                    </div>
                    <div class="nm-mobile-close" @click="menuHide">
                        <img src="./assets/images/icons/mbclose.png" alt="p3k melinda" />
                    </div>
                </div>
                <div class="navbar-menu-bg" id="navbar-menu-bg" @click="menuHide"></div>
                <div class="navbar-button">
                    <div class="nb-menumob">
                        <img src="./assets/images/icons/mobmenu.png" alt="p3k melinda" @click="menuShow" />
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="content">
        <router-view/>
    </div>
    <footer>
        <div class="footer-top">
            <div class="ft-detail">
                <div class="ft-detail-row">
                    <div class="fdr-image">
                        <img src="../src/assets/images/icons/lcicon.png" alt="morula melinda hospital"/>
                    </div>
                    <div class="fdr-text">
                        <p>RS. Melinda 2, Lantai 6 Jl. dr. Cipto No.1 Bandung.</p>
                    </div>
                </div>
                <div class="ft-detail-row">
                    <div class="fdr-image">
                        <img src="../src/assets/images/icons/phicon.png" alt="morula melinda hospital"/>
                    </div>
                    <div class="fdr-text">
                        <p>022 - 42690778 / 022 - 42690088</p>
                    </div>
                </div>
                <div class="ft-detail-row">
                    <div class="fdr-image">
                        <img src="../src/assets/images/icons/waicon.png" alt="morula melinda hospital"/>
                    </div>
                    <div class="fdr-text">
                        <p>0812 9507 1800</p>
                    </div>
                </div>
                <div class="ft-detail-row">
                    <div class="fdr-image">
                        <img src="../src/assets/images/icons/igicon.png" alt="morula melinda hospital"/>
                    </div>
                    <div class="fdr-text">
                        <p>@morulaivfmelindabandung</p>
                    </div>
                </div>
            </div>
            <div class="ft-logo">
                <img src="../src/assets/images/logos/morula.png" alt="morula melinda hospital"/>
            </div>
        </div>
        <div class="footer-bottom">
            <p>© Copyright Morula IVF Melinda Bandung {{ date.getFullYear() }}. All Right Reserved.</p>
        </div>
        <div class="notification" id="notification">
            <div class="notification-head">
                <h5 class="notification-message" id="notification-title"></h5>
            </div>
            <div class="notification-body">
                <p class="notification-message" id="notification-message"></p>
            </div>
        </div>
        <div class="chatbox" id="chatbox">
            <div class="chatbox-button">
                <a href="https://wa.me/6281295071800?text=halo....." target="_blank">
                    <div class="chatbox-image">
                        <img src="./assets/images/logos/wagreen.png" alt="morula melinda bandung"/>
                    </div>
                </a>
            </div>
        </div>
        <div class="go-top" @click="pageScrollTop">
            <img src="./assets/images/icons/arrow-1.png" alt="morula melinda hospital" />
        </div>
    </footer>
</template>
<script setup>
import { scrollSection } from '@/functions/general';
const date = new Date();
function menuToggle(){
    const nm = document.getElementById('navbar-menu');
    const nb = document.getElementById('navbar-menu-bg');
    if(screen.width <= 750){
        if(nm.style.left == '26%'){
            nm.style.left = '110%';
            nb.style.width = '0';
        }else{
            nm.style.left = '26%';
            nb.style.width = '100%';
        }
    }
    const np = document.getElementsByClassName('npa-option');
    for(var i = 0; i < np.length; i++){
        np[i].classList.remove('npa-option-active');
        np[i].style.height = 0;
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}
function menuShow(){
    document.getElementById('navbar-menu').style.left = '26%';
    document.getElementById('navbar-menu-bg').style.width = '100%';
}
function menuHide(){
    document.getElementById('navbar-menu').style.left = '110%';
    document.getElementById('navbar-menu-bg').style.width = '0';
}
function pageScrollTop(){
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}
</script>
<style>
    @font-face {
        font-family: 'roboto';
        src: url('assets/fonts/roboto/Roboto-Regular.ttf') format('truetype');
        font-display: swap;
    }
    @font-face {
        font-family: 'poppins';
        src: url('assets/fonts/poppins/Poppins-SemiBold.ttf') format('truetype');
        font-display: swap;
        font-weight: bold;
    }
    @font-face {
        font-family: 'poppins-light';
        src: url('assets/fonts/poppins/Poppins-Light.ttf') format('truetype');
        font-display: swap;
        /* font-weight: bold; */
    }
    @font-face {
        font-family: 'varela-round';
        src: url('assets/fonts/varela-round/VarelaRound-Regular.ttf') format('truetype');
        font-display: swap;
        /* font-weight: bold; */
    }
    @font-face {
        font-family: 'trueno';
        src: url('assets/fonts/trueno/TruenoRg.otf') format('opentype');
        font-display: swap;
        /* font-weight: bold; */
    }
    :root {
        --primary: #e6872f;
        --primary-hover: #e6ac2f;
        --white: #ffffff;
        --grey: #575757;
        --softgrey: lightgrey;
        --smoke: whitesmoke;
        --navy: #1B4674;
        --red: #CD4051;
        --cream: #FCE8CE;
        --cream-bg: #FEF8F0;
        --softcream: #F5F4F4;
    }
    *{
        box-sizing: border-box;
    }
    html{
        scroll-behavior: smooth;
        display: flex;
        justify-content: center;
        font-size: 16px;
    }
    body{
        width: 100%;
        margin: 0;
        font-family: poppins;
        font-size: 1rem;
        min-width: 250px;
        max-width: 2500px; /* same as .nav-pad */
    }
    ::-webkit-scrollbar{
        width: 0.5rem;
    }
    ::-webkit-scrollbar-thumb{
        background: var(--primary);
        border-radius: 1rem;
        transition: 0.2s;
    }
    ::-webkit-scrollbar-thumb:hover{
        background: var(--primary-hover);
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
    input:-webkit-autofill{
        -webkit-text-fill-color: var(--grey) !important;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number] {
        -moz-appearance: textfield;
    }
    @media print {
        .no-print{
            display: none;
        }
    }
    @keyframes pulse-bg{
        0%{
            background-color: #eee;
        }
        50%{
            background-color: #e0e0e0;
        }
        100%{
            background-color: #eee;
        }
    }
    @keyframes pulse-bg-transparent{
        0%{
            background-color: rgba(238, 238, 238, 0.658);
        }
        50%{
            background-color: #e0e0e065;
        }
        100%{
            background-color: rgba(238, 238, 238, 0.548);
        }
    }
    @keyframes pulse-bg-white{
        0%{
            background-color: #eee;
        }
        50%{
            background-color: #ffffff;
        }
        100%{
            background-color: #eee;
        }
    }
    @keyframes pulse-bg-navy{
        0%{
            background-color: #a1c1e2;
        }
        50%{
            background-color: #1B4674;
        }
        100%{
            background-color: #a1c1e2;
        }
    }
    @keyframes pulse-bg-bluesky{
        0%{
            background-color: #cceeff;
        }
        50%{
            background-color: #75C6EF;
        }
        100%{
            background-color: #cceeff;
        }
    }
    @-webkit-keyframes animatenlloption {
        from {top:200%; opacity:0}
        to {top:75%; opacity:1}
    }
    @keyframes animatenlloption {
        from {top:200%; opacity:0}
        to {top:75%; opacity:1}
    }
    @-webkit-keyframes animatenotification {
        from {right:-100%; opacity:0}
        to {right:10%; opacity:1}
    }
    @keyframes animatenotification {
        from {right:-100%; opacity:0}
        to {right:10%; opacity:1}
    }
    /* navbar */
    .navbar{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 4.81rem;
        display: flex;
        border: 1px solid whitesmoke;
        font-family: roboto;
        font-weight: 600;
        background: var(--white);
        z-index: 16;
        white-space: nowrap;
        user-select: none;
        transition: 0.2s;
        justify-content: center;
    }
    .nav-pad{
        width: 100%;
        max-width: 2500px; /* same as body */
        padding-top: 0.5rem;
        padding-left: 10%;
        padding-right: 10%;
        transition: 0.2s;
    }
    .navbar-inner{
        display: flex;
        flex-wrap: nowrap;
        text-align: center;
        height: 100%;
    }
    .navbar-logo{
        width: 36%;
        height: 100%;
        display: flex;
        justify-content: left;
        align-items: center;
        text-align: left;
        transition: 0.2s;
        overflow: hidden;
    }
    .navbar-logo a{
        text-decoration: none;
        color: #79b7f1;
    }
    .navbar-logo img{
        height: 75%;
        width: 100%;
        max-width: 200px;
    }
    .navbar-logo-text{
        font-style: italic;
        display: none;
    }
    .navbar-menu{
        width: 64%;
        display: flex;
        justify-content: right;
        padding-top: 0.7rem;
        transition: 0.2s;
        z-index: 15;
    }
    .navbar-menu-bg{
        position: fixed;
        top: 0;
        left: 110%;
        width: 0;
        height: 150%;
        background: #000000;
        opacity: 0.5;
        z-index: 10;
    }
    @-webkit-keyframes animatetop {
        from {top:-300px; opacity:0} 
        to {top:0; opacity:1}
    }
    @keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }
    .nm-inner{
        display: flex;
        flex-wrap: nowrap;
        background: var(--white);
    }
    .nm-part{
        padding: 0 0 0 2rem;
        width: auto;
        margin: auto;
    }
    .nm-part-link{
        text-decoration: none;
        color: #575757;
        transition: 0.2s;
    }
    .nm-part-link:hover{
        color: var(--primary);
    }
    .nm-part-arrow{
        position: relative;
        display: flex;
        justify-content: center;
        color: var(--grey);
    }
    .npa-button{
        display: flex;
        width: 100%;
        font-size: 0.9rem;
    }
    .router-link-active{
        color: var(--primary);
    }
    .nm-mobile{
        display: none;
        padding-top: 2rem;
    }
    .nm-mobile span{
        background: #FCE8CE;
        color: #575757;
        padding: 0.5rem;
        padding-left: 2rem;
        padding-right: 2rem;
        border-radius: 5px;
        transition: 0.2s;
    }
    .nm-mobile-close{
        display: none;
    }
    .nm-mobile-loggedin{
        display: none;
    }
    .navbar-button{
        width: 0;
        text-align: right;
        padding-right: 0;
        transition: 0.2s;
        overflow: hidden;
    }
    .navbar-button span{
        background: #FCE8CE;
        color: #575757;
        padding: 0.75rem;
        padding-left: 2rem;
        padding-right: 2rem;
        border-radius: 2rem;
        transition: 0.2s;
    }
    .navbar-button span:hover{
        background: #f7ce9a;
    }
    .nb-login-loggedin{
        position: relative;
        min-height: 50px;
        cursor: pointer;
    }
    .nll-button{
        background: unset;
        color: #575757;
        border-radius: 0;
        transition: 0.2s;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .nll-button:hover{
        background: var(--white);
    }
    .nll-select{
        position: absolute;
        top: 75%;
        right: 0;
        width: 100%;
        background: var(--white);
        color: var(--grey);
        border-radius: 5px;
        padding: 0.5rem;
        text-align: left;
        display: none;
        box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.15), 0 5px 20px 0 rgba(0, 0, 0, 0.15);
        animation-name: animatenlloption;
        animation-duration: 0.2s;
        transition: 0.2s;
        overflow: hidden;
    }
    .nll-option{
        cursor: pointer;
        padding: 0.5rem;
        transition: 0.2s;
    }
    .nll-option:hover{
        background: var(--smoke);
    }
    .nb-menumob{
        display: none;
        z-index: 100;
    }
    .nb-menumob img{
        max-width: 2rem;
    }
    .stb-active{
        position: fixed;
        top: 5.5rem;
        right: 10%;
        width: 24%;
    }
    .stb-absolute{
        position: absolute;
        right: 0;
        bottom: 1rem;
        width: 100%;
    }
    @media only screen and (min-width: 2501px){
        .nav-pad{
            padding-left: 16rem;
            padding-right: 16rem;
        }
    }
    @media only screen and (max-width: 1500px){
        @-webkit-keyframes animatenotification {
            from {right:-100%; opacity:0}
            to {right:5%; opacity:1}
        }
        @keyframes animatenotification {
            from {right:-100%; opacity:0}
            to {right:5%; opacity:1}
        }
        .nav-pad{
            padding-left: 5%;
            padding-right: 5%;
        }
        .navbar-menu{
            width: 88%;
        }
        .navbar-button{
            width: 0;
        }
        .stb-active{
            right: 5%;
            width: 27%;
        }
    }
    @media only screen and (max-width: 1200px){
        .nlf-inner{
            width: 50%;
        }
    }
    @media only screen and (max-width: 1050px){
        html{
            display: inline;
        }
        .navbar{
            font-size: 75%;
        }
        .navbar-button span{
            padding: 0.5rem;
            padding-left: 1rem;
            padding-right: 1rem;
        }
        .stb-active{
            position: relative;
            width: 100%;
            top: 0;
            right: 0;
        }
    }
    @media only screen and (max-width: 750px){
        .nav-pad{
            padding-top: 0.75rem;
            padding-left: 2.5%;
            padding-right: 2.5%;
        }
        .navbar-logo{
            width: 100%;
        }
        .navbar-menu{
            position: fixed;
            top: 0;
            left: 110%;
            width: 75%;
            height: 150%;
            transition: 0.2s;
            text-align: left;
            padding-left: 1%;
            padding-right: 15%;
            font-size: 1rem;
            background: var(--white);
            justify-content: left;
        }
        .nm-mobile-close{
            display: block;
            position: absolute;
            top: 1rem;
            right: 4.1%;
            width: 1.5rem;
            height: 1.5rem;
        }
        .nm-mobile-close img{
            width: 100%;
            max-width: 1.5rem;
            height: 100%;
        }
        .navbar-menu-bg{
            left: 0;
        }
        .navbar-login-form{
            padding-top: 0;
        }
        .nlf-inner{
            width: 100%;
            height: 100%;
            border-radius: 0;
        }
        .nm-inner{
            display: inline;
        }
        .nm-part{
            padding: 0.5rem 0 0.5rem 1rem;
        }
        .nm-part-arrow{
            display: inline;
            justify-content: left;
        }
        .npa-option{
            position: relative;
            display: block;
            height: 0;
            overflow: hidden;
            padding: 0 0 0 0;
        }
        .npa-option-inner{
            min-width: unset;
            width: 100%;
            box-shadow: unset;
            padding: 0 0 0 0;
            border: 1px solid var(--softgrey);
            margin: 1rem 0 1rem 0;
        }
        .nm-mobile{
            display: block;
        }
        .nm-mobile-loggedin{
            display: block;
        }
        .nm-mobile img{
            width: 1.5rem;
        }
        .navbar-button{
            width: 77%;
            padding: 1rem;
            padding-top: 0.5rem;
            padding-right: 0;
        }
        .nb-login{
            display: none;
        }
        .nb-login-loggedin{
            display: none;
        }
        .nb-menumob{
            display: block;
        }
    }
    /* content */
    .content{
        padding: 4.81rem 0 0 0;
        min-height: 500px;
    }
    /* footer */
    footer{
        position: relative;
        background: var(--white);
    }
    .footer-top{
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        padding: 2.5rem 10% 0 10%;
        background: var(--softgrey);
        color: var(--grey);
        transition: 0.2s;
    }
    .ft-detail{
        width: 50%;
        transition: 0.2s;
    }
    .ft-detail-row{
        width: 75%;
        display: flex;
        padding: 0.5rem 0 0.5rem 0;
    }
    .fdr-image{
        width: 15%;
    }
    .fdr-image img{
        width: 100%;
        max-width: 50px;
    }
    .fdr-text{
        width: 85%;
        font-size: 1.2rem;
        padding: 0 0 0 0.5rem;
        overflow-wrap: break-word;
        transition: 0.2s;
    }
    .fdr-text p{
        margin: 0;
    }
    .ft-logo{
        width: 50%;
        display: flex;
        justify-content: right;
        transition: 0.2s;
    }
    .ft-logo img{
        max-width: 200px;
    }
    .footer-bottom{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 1rem 10% 1rem 10%;
        background: var(--primary);
        color: var(--white);
        transition: 0.2s;
    }
    .footer-bottom p{
        margin: 0;
    }
    .cookies-link{
        margin-left: 1rem;
    }
    .notification{
        display: none;
        position: fixed;
        top: 100px;
        right: 10%;
        background: rgb(76, 155, 230);
        color: var(--white);
        min-width: 200px;
        min-height: 50px;
        border-radius: 5px;
        padding: 0.5rem;
        box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.15), 0 5px 20px 0 rgba(0, 0, 0, 0.15);
        user-select: none;
        animation-name: animatenotification;
        animation-duration: 0.5s;
        z-index: 100;
    }
    .chatbox{
        position: fixed;
        right: 0;
        bottom: 0;
        transition: 0.2s;
    }
    .chatbox-scrolled{
        right: 100px;
    }
    .chatbox-button{
        /* background: var(--white); */
        width: 75px;
        height: 75px;
        display: flex;
        justify-content: center;
        align-items: center;
        /* border: 1px solid green; */
        /* border-radius: 75px; */
        /* padding: 0 0 1rem 0; */
    }
    .chatbox-image img{
        width: 100%;
        /* max-height: 100%; */
    }
    .go-top{
        display: flex;
        position: fixed;
        right: 1%;
        bottom: -15%;
        width: 75px;
        height: 75px;
        background: #a1a2a359;
        color: #515253;
        justify-content: center;
        align-items: center;
        z-index: 19;
        border-radius: 5px;
        cursor: pointer;
        transition: 0.2s;
        user-select: none;
    }
    .go-top img{
        transform: rotate(180deg);
    }
    @media only screen and (max-width: 1650px){
        .fm-logo{
            width: 26%;
        }
        .fm-text{
            width: 74%;
        }
    }
    @media only screen and (max-width: 1500px){
        .footer-top{
            padding: 2.5rem 5% 0 5%;
        }
        .footer-middle{
            padding-left: 5%;
            padding-right: 5%;
        }
        .footer-bottom{
            padding: 1rem 5% 1rem 5%;
        }
        .notification{
            right: 5%;
        }
        .chatbox{
            bottom: 2.5%;
        }
        .chatbox-button{
            padding: 0.5rem;
        }
        .chatbox-scrolled{
            right: 67px;
        }
        .go-top{
            width: 50px;
            height: 50px;
            right: 1%;
        }
    }
    @media only screen and (max-width: 750px){
        .footer-top{
            padding: 2.5rem 2.5% 0 2.5%;
        }
        .ft-detail{
            width: 100%;
        }
        .ft-detail-row{
            width: 100%;
        }
        .fdr-text{
            font-size: 1rem;
        }
        .ft-logo{
            width: 100%;
            justify-content: left;
        }
        .footer-bottom{
            padding: 1rem 2.5% 1rem 2.5%;
        }
        .notification{
            right: 2.5%;
        }
        .chatbox{
            right: 0;
            bottom: 0;
        }
        .chatbox-scrolled{
            bottom: 64px;
        }
        .go-top{
            right: 2.5%;
            border-radius: 50px;
        }
    }
</style>